// extracted by mini-css-extract-plugin
export default {"control":"SearchBar_control__6xbye"};